import { useEffect } from 'react';

const useApiOptions = (apiResponse, setStateFunction) => {
  useEffect(() => {
    if (!apiResponse) return;

    setStateFunction(
      Object.entries(apiResponse).map(([key, resValue]) => ({
        label: resValue,
        value: key,
        isChecked: false,
      }))
    );
  }, [apiResponse, setStateFunction]);
};

export default useApiOptions;
